import { render, staticRenderFns } from "./CreaCartera.vue?vue&type=template&id=b66b4696"
import script from "./CreaCartera.vue?vue&type=script&lang=js"
export * from "./CreaCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports